import { http } from '@pendo/http';

export function fetchInitialFormData (type) {
    return http
        .get(`/api/s/_SID_/vocItem/form?type=${type}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function createVocItem (item) {
    return http
        .post('/api/s/_SID_/vocItem', item)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function updateVocItem (vocItemId, changes) {
    return http
        .patch(`/api/s/_SID_/vocItem/${vocItemId}`, changes)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function addVote (vocItemId, onBehalfOfId, onBehalfOfType, strength, comment, accountId) {
    return http
        .post(`/api/s/_SID_/vocItem/${vocItemId}/votes`, { onBehalfOfId, onBehalfOfType, strength, comment, accountId })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function revokeVote (vocItemId, voteId) {
    return http
        .patch(`/api/s/_SID_/vocItem/${vocItemId}/votes/${voteId}`, { revoked: true })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getPendoAccount (salesforceAccountId) {
    return http
        .get(`/api/s/_SID_/account/salesforce/${salesforceAccountId}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getPendoVisitor (salesforceContactId) {
    return http
        .get(`/api/s/_SID_/visitor/salesforce/${salesforceContactId}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function fetchVocItemData (vocItemId) {
    return http
        .get(`/api/s/_SID_/vocItem/${vocItemId}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function deleteVocItem (vocItemId) {
    return http.delete(`/api/s/_SID_/vocItem/${vocItemId}`).catch((err) => {
        throw err;
    });
}

export function loadAllVocItems () {
    return http
        .get('/api/s/_SID_/vocItem')
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function linkFeedbackToIdea ({ ideaId, feedbackId }) {
    return http
        .post(`/api/s/_SID_/vocItem/${ideaId}/link/${feedbackId}`, {
            headers: { 'Content-Type': 'application/json' },
        })
        .catch((err) => {
            throw err;
        });
}

export function unlinkFeedbackFromIdea ({ ideaId, feedbackId }) {
    return http
        .delete(`/api/s/_SID_/vocItem/${ideaId}/link/${feedbackId}`, {
            headers: { 'Content-Type': 'application/json' },
        })
        .catch((err) => {
            throw err;
        });
}

export function rejectSuggestion ({ suggestionId }) {
    return http
        .patch(
            `/api/s/_SID_/suggestion/${suggestionId}`,
            { state: 'rejected' },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .catch((err) => {
            throw err;
        });
}

export function fetchSuggestionEmbedding ({ title, description }) {
    const query = `${title} ${description}`;

    return http
        .post(
            '/api/s/_SID_/vocItem/ai/embedding',
            { content: query },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function loadSuggestions ({ embedding, type }) {
    return http
        .post(
            '/api/s/_SID_/vocItem/ai/knnsearch',
            { query_vector: embedding, type },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function deleteVocItemsFromASource ({ source, sourceCategory, sourceIdentifier, confirmDelete = false }) {
    return http
        .post(`api/s/_SID_/vocItem/delete?deleteMatchingItems=${confirmDelete}`, {
            source: {
                source,
                sourceCategory,
                sourceIdentifier,
            },
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function bulkLinkFeedbackToIdea ({ ideaId, feedbackIds, insightIds }) {
    return http
        .post(
            `/api/s/_SID_/vocItem/${ideaId}/bulkLink`,
            { feedbackIds, insightIds },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function bulkUpdateVocItems ({ fieldKey, ids, vocItemIds, operation = 'replace' }) {
    return http
        .patch(
            '/api/s/_SID_/vocItem/bulkUpdate',
            { [fieldKey]: ids, vocItemIds, operation },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function fetchBulkUpdateStatus () {
    return http
        .get('/api/s/_SID_/vocItem/bulkUpdate/status')
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function fetchStatusUpdates (vocItemId) {
    return http
        .get(`/api/s/_SID_/vocItem/${vocItemId}/statusupdates`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}
